import { Eyebrow, MaskLine, Reveal } from "@/components/Reveal";
import { useNews } from "@/components/NewsSection";
import CtaBand from "@/components/CtaBand";

const News = () => {
  const news = useNews();
  return (
  <>
    <section data-testid="news-hero" className="cta-glow pb-24 pt-44 sm:pb-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Eyebrow className="text-gold">News & Updates</Eyebrow>
        <h1 className="mt-6 max-w-4xl font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <MaskLine delay={0.15}>What's happening</MaskLine>
          <MaskLine delay={0.3}>at Sunkev.</MaskLine>
        </h1>
        <Reveal delay={0.5}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-white/70 md:text-lg">
            Milestones, product updates and announcements from Sunkev Enterprises Private
            Limited and the Craftsi platform.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        {news.map((n, i) => (
          <Reveal key={n.title} delay={i * 0.08}>
            <article
              data-testid={`news-item-${i}`}
              className="group flex gap-8 border-t border-gray-100 py-12 transition-colors duration-500 last:border-b hover:bg-mist/60"
            >
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-navy">
                <n.Icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
              </span>
              <div>
                <div className="flex flex-wrap items-center gap-3">
                  <span className="rounded-full bg-gold/15 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-dark">
                    {n.tag}
                  </span>
                  <span className="text-xs font-semibold uppercase tracking-wider text-fog">
                    {n.date}
                  </span>
                </div>
                <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-ink sm:text-3xl">
                  {n.title}
                </h2>
                <p className="mt-4 max-w-2xl text-base leading-relaxed text-fog">{n.text}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>

    <CtaBand />
  </>
  );
};

export default News;
